import React, { Component } from 'react';
import _ from 'lodash';
import { Translate, withTranslate } from 'core/translate';
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton,
  ModalFooterMessage
} from '../../common/modal/Modal';
import { DRIVE_TYPE } from './matrixConflictTypes';
import {
  buildDriveOptions,
  combineWithConfig
} from '../../common/configAssistant/data';
import MatrixConflictConfigAssistant from './MatrixConflictConfigAssistant';
import fetchModelMatrix from '../../api/fetchModelMatrix';
import { withModelInfo } from '../../common/ModelInfoContext';

const findSelectedDriveOption = (driveType, rearWheelType, options) =>
  _.find(options, { driveType, rearWheelType }) ||
  _.find(options, { driveType }) ||
  _.first(options);

class MatrixConflictModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      groups: {},
      isLoaded: false,
      selectedDriveOption: null,
      selectedOption: null
    };
  }

  componentDidMount() {
    const { modelInfo, config, type, id } = this.props;

    const styleId = type === 'styleId' ? id : null;

    fetchModelMatrix({ ...modelInfo, config, styleId })
      .then(combineWithConfig(config))
      .then(options => {
        const driveOptions = buildDriveOptions(options, config.driveTypes);

        const driveType =
          type === DRIVE_TYPE ? id : config.selections.driveType;
        const rearWheelType = config.selections.rearWheelType;

        const selectedDriveOption = findSelectedDriveOption(
          driveType,
          rearWheelType,
          driveOptions
        );

        this.setState({
          isLoaded: true,
          options,
          driveOptions,
          selectedDriveOption
        });
      });
  }

  onDriveOptionChange = option => {
    this.setState({
      selectedDriveOption: option,
      selectedOption: null
    });
  };

  onOptionChange = option => {
    this.setState(prevState => ({
      selectedOption: prevState.selectedOption === option ? null : option
    }));
  };

  onSubmit = () => {
    this.props.onSubmit(this.state.selectedOption);
  };

  render() {
    const { translate, classicModel, type, id, onClose } = this.props;
    const {
      isLoaded,
      driveOptions,
      options,
      selectedDriveOption,
      selectedOption
    } = this.state;

    const header = translate('configuration.assistant');

    return (
      <Modal
        isOpen={true}
        className="reveal--narrow"
        contentLabel={header}
        onRequestClose={onClose}>
        <ModalHeader icon="bell" text={header} onClose={onClose} />
        <ModalBody>
          {isLoaded ? (
            <MatrixConflictConfigAssistant
              options={options}
              driveOptions={driveOptions}
              type={type}
              id={id}
              classicModel={classicModel}
              selectedDriveOption={selectedDriveOption}
              selectedOption={selectedOption}
              onDriveOptionChange={this.onDriveOptionChange}
              onOptionChange={this.onOptionChange}
            />
          ) : null}
        </ModalBody>
        <ModalFooter>
          <ModalFooterMessage>
            {!selectedOption ? (
              <Translate value="configuration.assistant.continue" />
            ) : null}
          </ModalFooterMessage>
          <ModalFooterButtons>
            <ModalFooterCancelButton onClick={onClose} data-dtm={header} />
            <ModalFooterPrimaryButton
              onClick={this.onSubmit}
              disabled={!isLoaded || !selectedOption}
              data-dtm={header}>
              <Translate value="byo.page.general.select" />
            </ModalFooterPrimaryButton>
          </ModalFooterButtons>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withTranslate(withModelInfo(MatrixConflictModal));
